export default "__VITE_ASSET__f3120151__"